<template>
    <form method="post" role="form" action="/Account/ViewProfile" novalidate="novalidate">
        <div class="card rounded-0 mb-3">
            <h3 class="card-header">
                Profile
            </h3>
            <div class="card-body">
                <div class="alert-success">{{successMessage}}</div>
                <div class="alert-warning">{{failureMessage}}</div>
                <div class="form-group">
                    <div class="row">
                        <label for="Email" class="col-4 d-flex align-self-center justify-content-end">
                            Email
                        </label>
                        <div class="col-8">
                            <input class="form-control rounded-0" disabled="" type="email" id="Email" maxlength="255" name="Email" v-model="profile.email">
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <label for="FirstName" class="col-4 d-flex align-self-center justify-content-end">
                            First Name
                            <span class="required">*</span>
                        </label>
                        <div class="col-8">
                            <input class="form-control rounded-0" type="text" id="FirstName" name="FirstName" maxlength="255" v-model="profile.firstName">
                        </div>
                    </div>
                    <div class="row" v-if="v$.profile.firstName.$error">
                        <div class="text-danger small col-4 offset-2" v-for="error of v$.profile.firstName.$silentErrors" :key="error.$message">
                            {{ error.$message }}
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <label for="LastName" class="col-4 d-flex align-self-center justify-content-end">
                            Last Name
                            <span class="required">*</span>
                        </label>
                        <div class="col-8">
                            <input class="form-control rounded-0" type="text" id="LastName" maxlength="255" name="LastName" v-model="profile.lastName">
                        </div>
                    </div>
                    <div class="row" v-if="v$.profile.lastName.$error">
                        <div class="text-danger small col-4 offset-2" v-for="error of v$.profile.lastName.$silentErrors" :key="error.$message">
                            {{ error.$message }}
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <label for="Company" class="col-4 d-flex align-self-center justify-content-end">
                            Company Name
                            <span class="required">*</span>
                        </label>
                        <div class="col-8">
                            <input class="form-control rounded-0" type="text" id="CompanyName" maxlength="255" name="CompanyName" v-model="profile.companyName">
                        </div>
                    </div>
                    <div class="row" v-if="v$.profile.companyName.$error">
                        <div class="text-danger small col-4 offset-2" v-for="error of v$.profile.companyName.$silentErrors" :key="error.$message">
                            {{ error.$message }}
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <label for="Industry" class="col-4 d-flex align-self-center justify-content-end">
                            Industry
                            <span class="required">*</span>
                        </label>
                        <div class="col-8">
                            <select id="Industry" v-model="profile.industryId" class="form-control rounded-0">
                                <option value="" disabled>-- Select Industry --</option>
                                <option v-for="industryItem in industries" v-bind:key="industryItem.text" :value="industryItem.value">
                                    {{industryItem.text}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row" v-if="v$.profile.cadTool.$error">
                        <div class="text-danger small col-4 offset-2" v-for="error of v$.profile.cadTool.$silentErrors" :key="error.$message">
                            {{ error.$message }}
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <label for="CadTool" class="col-4 d-flex align-self-center justify-content-end">
                            Preferred CAD Tool
                            <span class="required">*</span>
                        </label>
                        <div class="col-8">
                            <select id="CadTool" v-model="profile.cadTool" class="form-control rounded-0">
                                <option disabled value="">-- Select a CAD tool --</option>
                                <option v-for="cadItem in cadtools" v-bind:key="cadItem.text" :value="cadItem.value">
                                    {{cadItem.text}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row" v-if="v$.profile.cadTool.$error">
                        <div class="text-danger small col-4 offset-2" v-for="error of v$.profile.cadTool.$silentErrors" :key="error.$message">
                            {{ error.$message }}
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <label for="Address1" class="col-4 d-flex align-self-center justify-content-end">
                            Address Line 1
                        </label>
                        <div class="col-8">
                            <input class="form-control rounded-0" type="text" id="Address1" maxlength="255" name="Address1" v-model="profile.address1">
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <label for="Address2" class="col-4 d-flex align-self-center justify-content-end">
                            Address Line 2
                        </label>
                        <div class="col-8">
                            <input class="form-control rounded-0" type="text" id="Address2" maxlength="255" name="Address2" v-model="profile.address2">
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <label for="Address3" class="col-4 d-flex align-self-center justify-content-end">
                            Address Line 3
                        </label>
                        <div class="col-8">
                            <input class="form-control rounded-0" type="text" id="Address3" maxlength="255" name="Address3" v-model="profile.address3">
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <label for="City" class="col-4 d-flex align-self-center justify-content-end">
                            City
                        </label>
                        <div class="col-8">
                            <input class="form-control rounded-0" type="text" id="City" maxlength="50" name="City" v-model="profile.city">
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <label for="CountryId" class="col-4 d-flex align-self-center justify-content-end">
                            Country
                            <span class="required">*</span>
                        </label>
                        <div class="col-8">
                            <select id="CountryId" v-model="profile.countryId" class="form-control rounded-0 country-id">
                                <option value="" disabled>-- Select Country --</option>
                                <option v-for="country in countries" v-bind:key="country.text" :value="country.value">
                                    {{country.text}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row" v-if="v$.profile.countryId.$error">
                        <div class="text-danger small col-4 offset-2" v-for="error of v$.profile.countryId.$silentErrors" :key="error.$message">
                            {{ error.$message }}
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <label for="Province" class="col-4 d-flex align-self-center justify-content-end">
                            State/Province
                        </label>
                        <div class="col-8">
                            <input class="form-control province" type="text" v-show="!showStatesDropDown" maxlength="50" name="StateProvinceCounty" v-model="profile.stateProvinceCounty">
                            <select id="StateProvinceCountyDropDown" name="StateProvinceCountyDropDown" v-show="showStatesDropDown" class="form-control validate-content province-dropdown" v-model="profile.stateProvinceCounty">
                                <option disabled selected value="">-- Select State --</option>
                                <option v-for="state in currentStates" v-bind:key="state.name" :value="state.name">
                                    {{state.name}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <label for="PostalCode" class="col-4 d-flex align-self-center justify-content-end">
                            Zip Or Postal Code
                        </label>
                        <div class="col-8">
                            <input class="form-control rounded-0" type="text" id="ZipOrPostalCode" maxlength="50" name="ZipOrPostalCode" v-model="profile.zipOrPostalCode">
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <label for="PhoneNumber" class="col-4 d-flex align-self-center justify-content-end">
                            Phone Number
                        </label>
                        <div class="col-8">
                            <input class="form-control rounded-0" type="tel" id="PhoneNumber" name="PhoneNumber" v-model="profile.phoneNumber">
                        </div>
                    </div>
                </div>
            </div>
            <div class="alert-success">{{successMessage}}</div>
            <div class="alert-warning">{{failureMessage}}</div>
            <div class="card-footer text-right">
                <input id="update" type="submit" class="btn btn-light" :disabled="v$.profile.$invalid" value="Update Profile" @click.prevent="postForm" />
            </div>
        </div>
    </form>
</template>

<script>
    import { mapState } from 'vuex'
    import accountApiClient from '@/services/apiServices/accountApiClient.js'
    import useVuelidate from '@vuelidate/core'
    import { required } from '@vuelidate/validators'

    export default {
        name: 'UserPanel',
        setup() {
            return { v$: useVuelidate() }
        },
        data() {
            return {
                profile: {
                    email: "",
                    companyName: "",
                    firstName: "",
                    lastName: "",
                    countryId: "",
                    address1: "",
                    address2: "",
                    address3: "",
                    city: "",
                    stateProvinceCounty: "",
                    zipOrPostalCode: "",
                    phoneNumber: "",
                    industryId: "",
                    cadTool: "",
                },
                successMessage: "",
                failureMessage: ""
            }
        },
        validations() {
            return {
                profile: {
                    companyName: { required, $autoDirty: true },
                    firstName: { required, $autoDirty: true },
                    lastName: { required, $autoDirty: true },
                    industryId: { required, $autoDirty: true },
                    cadTool: { required, $autoDirty: true },
                    countryId: { required, $autoDirty: true }
                }
            }
        },
        props: {
            countries: {
                type: Array,
                default: () => []
            },
            states: {
                type: Array,
                default: () => []
            },
            industries: {
                type: Array,
                default: () => []
            },
            cadtools: {
                type: Array,
                default: () => []
            },
            initialProfile: {
                email: "",
                companyName: "",
                firstName: "",
                lastName: "",
                countryId: "",
                address1: "",
                address2: "",
                address3: "",
                city: "",
                stateProvinceCounty: "",
                zipOrPostalCode: "",
                phoneNumber: "",
                industryId: "",
                cadTool: "",
            }
        },
        computed: {
            ...mapState({
                instance: state => state.instance,
            }),
            currentStates: function () {
                return this.states.filter(x => x.countryId == this.profile.countryId);
            },
            showStatesDropDown: function () {
                return this.currentStates.length > 0;
            },
        },
        methods: {
            postForm: async function () {
                var value = await accountApiClient.PostProfile(this.profile.email, this.profile.companyName, this.profile.firstName, this.profile.lastName, this.profile.industryId, this.profile.countryId, this.profile.cadTool, this.profile.address1, this.profile.address2, this.profile.address3, this.profile.city, this.profile.stateProvinceCounty, this.profile.zipOrPostalCode, this.profile.phoneNumber);
                if (value.status == 200) {
                    if (value.data.success) {
                        this.successMessage = value.data.message;
                    } else {
                        this.failureMessage = value.data.message;
                    }
                } else {
                    this.failureMessage = "Server Interruption"
                }

            }
        },
        watch: {
            'initialProfile': {
                handler: function (val) {
                    this.profile = Object.assign({}, val);
                    this.successMessage = '';
                    this.failureMessage = '';
                },
                deep: true
            },
            'successMessage': {
                handler: function () {
                    this.failureMessage = '';
                }
            },
            'failureMessage': {
                handler: function () {
                    this.successMessage = '';
                }
            }
        }
    }
</script>

<style scoped>
</style>